export const ENV = import.meta.env.VITE_ENV || "development";
export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3002";
export const BENEVOLAT_URL = import.meta.env.VITE_BENEVOLAT_URL || "http://localhost:3001";
export const VOLONTARIAT_URL = import.meta.env.VITE_VOLONTARIAT_URL || "http://localhost:3001";
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN?.trim();
